import { useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { ProgressBar } from "components/molecules";
import { ListSalesChannels } from "components/organism";
import { Button } from "components/atoms";
import { useOnBoardingGs1 } from "partner/_hooks";
import { useOnBoarding } from "_hooks";

const prefix = "vv-sales-channels";

const SalesChannels = () => {
  const { state } = useLocation();
  const navigate = useNavigate();

  const { fetchSalesChannels, salesChannelsList } = useOnBoarding();
  const { logoutAuth0, lookAndFeel, resetEnrollmentStep, sendSalesChannels } = useOnBoardingGs1();
  const { partner } = useParams();
  const initialized = useRef(null);
  const { isLoading } = useSelector((s) => s.partner?.[partner]?.enrollmentStepGs1);
  const [selected, setSelected] = useState([]);

  const checkIt = useCallback(() => {
    if (!initialized?.current) {
      initialized.current = true;
      if (!state?.token || !state?._id || !state?.email) {
        logoutAuth0(partner);
        navigate(`/partner/${partner}/auth0`);
      } else if (!salesChannelsList) {
        fetchSalesChannels();
      }
    }
  }, [logoutAuth0, navigate, fetchSalesChannels, partner, salesChannelsList, state]);

  const onToggle = (value) => setSelected((s) => {
    let aux = [...s];
    let search = aux.indexOf(value)
    if (search !== -1) {
      aux.splice(search, 1);
    } else {
      aux.push(value);
    }
    return aux;
  });

  const submit = () => sendSalesChannels(state?._id, {
    channelsKey: selected
  }).then((d) => {
    if (d) {
      navigate(`/partner/${partner}/create`, { state });
    }
  });

  useEffect(() => {
    return () => resetEnrollmentStep();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    checkIt();
  }, [checkIt]);
  
  return (
    <div className={prefix}>
      <div className="mb-5">
        <ProgressBar
          progress={4} max={5} 
          color={lookAndFeel?.progressbar}
        />
      </div>
      <div className="flex flex-wrap flex-col gap-5">
          
        <p className="ttext-center text-3xl font-bold mx-auto">Canales de venta</p>
        <p className="text-center text-base mx-auto pb-5">¿En dónde publicas tus productos?</p>

        <ListSalesChannels 
          country="GS1 México"
          flag="mx"
          elements={salesChannelsList?.filter(
            (s) => ("mx" === s?.["country-code"] && s?.forks?.includes(partner))
          )
            .map(({key, name}) => ({
              key,
              content: name
            })) ?? []
          }
          onToggle={onToggle}
          selected={selected}
        />

        <Button
          className="h-10 text-white rounded-lg mt-5"
          disabled={isLoading || !selected.length}
          fullwidth
          onClick={submit}
          pulse
          spin={isLoading}
          style={{
            backgroundColor: lookAndFeel?.primary?.solid,
            color: lookAndFeel?.primary?.text
          }}
          type="submit"
        >Continuar</Button>
      </div>
    </div>
  );
};

export default SalesChannels;
